import { ACTIVITY_MARK, ACTIVITY_RESET } from '../constants/actionTypes';

const initialState = {
	type: false,
	time: false,
};

export default function activity(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case ACTIVITY_MARK:
			return {
				...state,
				type: payload.type,
				time: payload.time,
			};

		case ACTIVITY_RESET:
			return initialState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activity.js